export interface LegalDocument {
  key: number
  documentType: LegalDocumentType
  productClassId?: string
  planPeriodId?: string
  title: string
  description: string | null
  fileUrl?: string
  apiUrl?: string
}

export enum LegalDocumentType {
  LegalDocument = 0,
  SummaryPlanDescriptionDocument = 1,
  ExhibitDocument = 2,
  ScheduleClassDocument = 3,
  SummaryBenefitsCoverageDocument = 4,
  PeopleKeepServicesAgreementDocument = 5,
  StaticFile = 6,
  DynamicFile = 7,
}
